Application.Project = {
    ui: {
        form: '.js-form--project',
        submit: '.js-form__submit',
        back: '.js-form__back',
        field: '.js-form__field',
        aside: '.js-form__aside',
        projectRadio: '.js-form__project-radio',
        project: '.js-form__project',
        projectSlider: '.js-form__project .slider',
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.form).length){
            return;
        }

        // validate
        $(this.ui.field).change(function(e){
            self.setSubmitState(self.isValid());
            self.updateProject();
        });
        self.setSubmitState(self.isValid());
        self.updateProject();

        // submit
        $(this.ui.submit).click(function(e){
            e.preventDefault();
            self.submit($(this).closest(self.ui.form).attr('action'), $(this).attr('href'));
        });

        // back
        $(this.ui.back).click(function(){
            self.showLoader();
        });

        // auto-select, if only one available
        if ($(this.ui.projectRadio).length == 1){
            setTimeout(function () {
                $(self.ui.projectRadio).click();
            }, 50);
        }

    },
    submit: function (action, next) {

        if (!this.isValid()){
            return false;
        }

        this.showLoader();

        $.post(action, this.getData(), function(data){
            if (data.result){
                // all done, go to next step
                window.location.href = next;
            }
        }, 'json');

    },
    setSubmitState: function(enabled){

        if (enabled){
            $(this.ui.submit).removeClass('disabled');
        }else{
            $(this.ui.submit).addClass('disabled');
        }

    },
    getData: function(){

        var self = this;
        var data = {};

        $(this.ui.field).each(function(){
            var name = $(this).attr('name');
            if ($(this).is('[type="radio"]')){
                data[name] = $(self.ui.field).filter('[name="' + name + '"]:checked').val();
            } else if ($(this).is('[type="checkbox"]')){
                data[name] = $(this).is(':checked') ? 1 : 0;
            }else{
                data[name] = $(this).val();
            }
        });

        return data;

    },
    isValid: function(){

        var data = this.getData();

        if (!data.project){
            return false;
        }

        return true;

    },
    updateProject: function(){

        var data = this.getData();

        if (data.project && $(this.ui.project).filter('[data-id="' + data.project + '"]').length){
            $(this.ui.aside).addClass('active');
            $(this.ui.project).removeClass('active').filter('[data-id="' + data.project + '"]').addClass('active');
            // update slick slider rendering
            try {
                $(this.ui.projectSlider).slick('refresh');
            }catch(exc){}
        }else{
            $(this.ui.aside).removeClass('active');
        }

    },
    showLoader: function(){

        $('body').addClass('loading');

    }
};